import { NetworkAccountAvatarProps } from '#/interfaces/NetworkAccountAvatarProps';
import { toSvg } from 'jdenticon';
import { useMemo } from 'react';

export default function JdenticonAccountAvatar({
  address,
  diameter = 24,
  ...props
}: NetworkAccountAvatarProps) {
  const src = useMemo(() => toSvg(address, diameter), [address, diameter]);
  return <div {...props} dangerouslySetInnerHTML={{ __html: src }} />;
}
